import moment from 'moment';

export const getColumnDefitions = (props) => {
    const { screenDetails: { screenColumns } } = props;
    const nglColDefs = getCompleteJSON(screenColumns, 'NGL')
    const butaneColDefs = getCompleteJSON(screenColumns, 'Butane')
    const condensateColDefs = getCompleteJSON(screenColumns, "Condensate")
    const isoButaneColDefs = getCompleteJSON(screenColumns, "Iso-Butane")
    const normalButaneColDefs = getCompleteJSON(screenColumns, "Normal Butane")
    const propaneColDefs = getCompleteJSON(screenColumns, "Propane")

    

    return {
        nglColDefs,
        butaneColDefs,
        condensateColDefs,
        isoButaneColDefs,
        normalButaneColDefs,
        propaneColDefs
    }
}

export const getCompleteJSON = (scrCols, colName) => {
    let selectedDef = {}
    let colDef = scrCols.filter(item => item.rowKey === colName)?.[0] || []
    let convertedColDef = []
    if (Object.keys(colDef)?.length) {
        try {
            let name = (typeof colDef.name !== 'undefined' && colDef.name != null ? 
                (colDef.name).trim() : '');
            let title = (typeof colDef.title !== 'undefined' && colDef.title != null ? 
                (colDef.title).trim() : "");
            let concatDef = String(name) + String(title);
            selectedDef = JSON.parse(atob(concatDef));

            convertedColDef = selectedDef.map((item) => {
                return Object.entries(item).reduce((pre, [key, value]) => {
                    if (typeof value === "string" && value.startsWith("/Function(") &&
                        value.endsWith(")/")
                    ) {
                        value = value.substring(10, value.length - 2);
                        pre[key] = (0, eval)("(" + value + ")")
                    } else {
                        pre[key] = value
                    }
                    return pre
                }, {})
            })
        } catch (err) {
            console.error(err)
        }
    }

    return convertedColDef
}
